
import './App.css';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { AppRoutes } from './routes';
// import { Header } from './components/common/Header/Header';
// import { Footer } from './components/common/Footer/Footer';
import Header from './components/common/Header/Header2';
import Footer from './components/common/Footer/Footer2';
import { useWebsiteCounter } from './hooks/useWebsiteCounter';
import FloatingSocial from './components/common/FloatingIcon/FloatingIcon';
import { useAuth } from './hooks/useAuth';
function App() {
  const { totalCount, isLoading: counterLoading } = useWebsiteCounter();
  const location = useLocation();
  const currentPath = location.pathname;
  console.log(currentPath)
  console.log('Current path:', currentPath);
  const { user } = useAuth();

  const hideOnDashboard = user && currentPath.startsWith('/dashboard');
  const showHeaderAndFooter = !hideOnDashboard;

  return (
    <div>
      {showHeaderAndFooter && <Header />}
      <AppRoutes />
      {showHeaderAndFooter && <Footer />}
      {showHeaderAndFooter && <FloatingSocial />}
    </div>
  );
}

export default App;
